
import { Options, Vue } from 'vue-class-component'
import AccountInfo from '@/components/account-info/account-info.vue'
import LoadingBar from '@/components/loading-bar/loading-bar.vue'
import liff from '@line/liff'
import * as meService from '@/services/line-web-loyalty-bff/v1/me'
import ModalBottom from '@/components/modal-bottom/modal-bottom.vue'
import ModalBottomBarcode from '@/components/modal-bottom-barcode/modal-bottom-barcode.vue'
import ModalBottomGoldOnboard from '@/components/modal-bottom-gold-onboard/modal-bottom-gold-onboard.vue'
import ModalBottomTieredPoints from '@/components/modal-bottom-tiered-points/modal-bottom-tiered-points.vue'
import CoinHistoryPage from '@/components/coin-history/coin-history-page.vue'
import ModalBottomCoinHistory from '@/components/modal-bottom-coin-history/modal-bottom-coin-history.vue'
import ModalBottomNotification from '@/components/modal-bottom-notification/modal-bottom-notification.vue'
import ModalEditProfilePage from '@/components/modal-edit-profile-page/modal-edit-profile-page.vue'
import ModalRightFullPageNotification from '@/components/modal-right-full-page-notification/modal-right-full-page-notification.vue'
import ModalRightFullPage from '@/components/modal-right-full-page/modal-right-full-page.vue'
import ModalBanner from '@/components/modal-banner/modal-banner.vue'
import ModalRightFullPageOptions from '@/interfaces/modal-right-full-page-options'
import ModalBottomOptions, { ReasonList } from '@/interfaces/modal-bottom-options'
import { getLocalFromInterPhone } from '@/helpers/formatter'
import ClubcardOnline from '@/components/clubcard-online/clubcard-online.vue'
import FreeCoupon from '@/components/free-coupon/free-coupon.vue'
import Campaign from '@/components/campaign/campaign.vue'
import SpecialStore from '@/components/special-store/special-store.vue'
import LineInfo, { LineProfile } from '@/interfaces/line-info'
import { Router } from 'vue-router'
import * as LiffService from '@/services/liff'
import Banners from '@/components/banners/banners.vue'
import { ModalImage } from '@/model/modal-image.model'
import { getLocalStorage, setLocalStorage, removeLocalStorage } from '@/helpers/cacheStorage'
import { KeyCache } from '@/model/key-cache.model'
import CustomerInfo from '@/interfaces/customer-info'
import CacheInfo from '@/interfaces/cache-info'
import VersionCopyright from '@/components/version-copyright/version-copyright.vue'
import { useStore } from '@/store'
import ModalIframe from '@/components/modal-iframe/modal-iframe.vue'
import { modalOptionsCouponLotus, getUrlModalOptionsMyCoupon, modalOptionsBanner } from '@/model/modal-options.model'
import { MyCoupon, MyCouponType } from '@/model/my-coupon.model'
import { MyCouponInfoPayload } from '@/interfaces/store/myCouponInfo'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'
import { isValidImageUrl, isWithinDisplayPeriod } from '@/helpers/validator'
import { CustomerTypeState, DisplayMode } from '@/model/event-code-configs.model'
import { triggerHealthCheck } from '@/services/line-web-loyalty-bff/v1/me'
import { modalOptionsSubmitError } from '@/model/modal-options.model'
import EventCodeConfigs, { CustomBanner, OnBoardingOption } from '@/interfaces/event-code-configs'
import { buildQueryParams } from '@/helpers/encodeURI'
import NewModalRightFullPage from '@/components/new-modal-right-full-page/new-modal-right-full-page.vue'
import GameIFrame from '@/components/game-iframe/game-iframe.vue'
import { markRaw } from 'vue'
import Modal from '../../interfaces/modal'
import BannersList from '@/components/banners-list/banners-list.vue'
import { BannersListPayload } from '@/interfaces/store/bannersList'
import DefaultBanner from '@/components/default-banner/default-banner.vue'
import { getEventPostMessage } from '@/helpers/eventPostMessage'
import { Game } from '@/model/game.model'
import { isDeeplinkFormat, isWebsiteFormat } from '@/helpers/validator'
import { IframeMessage } from '@/interfaces/modal-iframe-options'
import BarcodeModal from '@/components/modal-barcode/modal-barcode.vue'
import { CampaignInfoPayload } from '@/interfaces/store/campaignInfo'
import ModalBottomDynamic from '@/components/new-modals/ModalBottomDynamic.vue'
import { addNewModal, NewModal } from '@/utils/modal'
import VoucherReward from '@/components/voucher-reward/voucher-reward.vue'
import PremiumReward from '@/components/premium-reward/premium-reward.vue'
import DefaultIFrame from '@/components/default-iframe/default-iframe.vue'
import { getConfigurationsMaMode } from '@/services/ma-mode-bff/configurations'
import { getDateStatus } from '@/helpers/date'

let router: Router // this variable is used to store router to avoid 'this' scope conflict
type ModalType = 'modal-right-full-page' | 'modal-bottom-dynamic' | 'modal-center-screen'

@Options({
  components: {
    AccountInfo,
    LoadingBar,
    ModalBottom,
    ModalBottomBarcode,
    ModalBottomNotification,
    ModalEditProfilePage,
    ModalRightFullPageNotification,
    ModalBottomDynamic,
    ModalRightFullPage,
    ModalBanner,
    ModalIframe,
    ModalBottomTieredPoints,
    ClubcardOnline,
    FreeCoupon,
    Campaign,
    PremiumReward,
    VoucherReward,
    SpecialStore,
    Banners,
    VersionCopyright,
    CoinHistoryPage,
    ModalBottomCoinHistory,
    NewModalRightFullPage,
    GameIFrame,
    BannersList,
    DefaultBanner
  },
  computed: {
    isLoading() {
      return this.$store.state.app.isLoadingHome
    },
    isOnline() {
      return this.$store.state.connectivity.isOnline
    },
    isTimeout() {
      return this.$store.state.connectivity.isTimeout
    },
    loadingBarLabelHtml() {
      return this.$store.state.app.loadingBarLabelHtml
    },
    isTokenExpired() {
      return this.$store.state.modalNotification.isModalTokenExpiredActive
    },
    isModalEditProfilePageActive() {
      return this.$store.state.modalEditProfile.isModalActive
    },
    isModalNotificationActive() {
      return this.$store.state.modalNotification.isModalActive
    },
    isModalTieredPointsActive() {
      return this.$store.state.modalTieredPoints.isModalActive
    },
    isCoinHistory() {
      return this.$store.state.coinHistory.isModalActive
    },
    isModalCalendarCoinHistory() {
      return this.$store.state.coinHistory.isModalCalendar
    },
    modalOptionsRightFullPageNotification() {
      this.$store.dispatch('connectivity/checkOnlineStatus')
      return this.isTokenExpired ? this.$store.state.modalNotification.modalOptions : this.$store.state.connectivity.modalOptionsRightFullPageNotification 
    },
    isModalIframeActive() {
      return this.$store.state.modalIframe.isModalIframeActive
    },
    isCouponLineDivisionActive() {
      let isActive = true
      const couponsStore = this.$store.state.myCouponInfo.coupons
      const premiumOffersStore = this.$store.state.myCouponInfo.premiumOffers
      const voucherOffersStore = this.$store.state.myCouponInfo.voucherOffers
      if (!couponsStore.isLoading && couponsStore.items.length === 0 && !premiumOffersStore.isLoading && premiumOffersStore.items.length === 0 && !voucherOffersStore.isLoading && voucherOffersStore.items.length === 0) {
        isActive = false
      }
      return isActive
    },
    isModalBannerActive() {
      return this.$store.state.modalBanner.isModalActive
    },
    modalOptionsBanner() {
      return this.$store.state.modalBanner.modalOptions
    },
    isUnlinkActive() {
      return this.$store.state.modalBanner.isUnlinkActive
    },
  }
})
export default class Home extends Vue {
  private store = useStore()
  private lineInfo: LineInfo = {
    idToken: '',
    profile: {
      displayName: '',
      pictureUrl: '',
      statusMessage: '',
      userId: ''
    },
    socialToken: '',
  }
  
  private customerInfo?: CustomerInfo = undefined
  private copyRightDate = ''


  isModalActive = false
  isShowOnBoarding = false
  isModalBarcodeActive = false
  isModalRightFullPageActive = false
  startToFadeOut = false
  lineLiffIdLoyalty = process.env.VUE_APP_LINE_LIFF_ID_LOYALTY
  lineLiffIdWebRegis = process.env.VUE_APP_LINE_LIFF_ID_WEB_REGISTER
  lineChannelId = process.env.VUE_APP_LINE_CHANNEL_ID
  webRegisUri = process.env.VUE_APP_WEB_REGISTER_URI
  isInProgress = false
  isFirstLoading = true
  forceUpdate = false
  gameUrl = process.env.VUE_APP_GAME_BASE_URL ?? ''
  openUrlHasBeenBlured = false
  openUrlBlurCounting = 0
  isShowingLoadingTransparency = false
  modals: Modal[] = []
  onBoardingOption: null | OnBoardingOption = null
  defaultConfig: EventCodeConfigs | Record<string, unknown> = {}
  isLoadingCustomerProfile = true
  newModals: NewModal[] = []

  private modalOptionsUnlink?: ModalBottomOptions = {
    classNameHeader: 'modal-account-info-unlink',
    title: 'ยกเลิกการเชื่อมต่อบัญชี LINE?',
    body: 'เพื่อช่วยให้เราพัฒนาการบริการให้ดียิ่งขึ้น    โปรด ระบุเหตุผลในการยกเลิกการเชื่อมต่อบัญชีของคุณ',
    actionOptions: [
      {
        text: 'ยกเลิก',
        color: '#424242',
        backgroundColor: '#E8E8E8',
        inProgressColor: '#E8E8E8',
        validate: false
      },
      {
        text: 'ยืนยัน',
        color: '#FFFFFF',
        backgroundColor: '#E1221C',
        inProgressColor: '#FCCCCA',
        validate: true,
        action: async (payload: any) => {
          await this.unlinkLineAccount(payload.reasonList)
        },
      },
    ]
  }

  private modalOptionsUnlinkConfirmation?: ModalRightFullPageOptions = {
    classNameHeader: 'modal-unlink-confirmation',
    image: ModalImage.UNLINK_CONFIRMATION_ICON,
    title: 'ยกเลิกการเชื่อมต่อบัญชี LINE',
    body: {
      topic: 'คำอธิบายการยกเลิกการเชื่อมต่อบัญชี LINE',
      title: 'การยกเลิกการเชื่อมต่อบัญชี LINE หมายถึง',
      highlight: '“บัญชีผู้ใช้นี้จะไม่สามารถเช็คโลตัสคอยน์และ<br/>ดูรีวอร์ดได้ แต่ยังสามารถรับข่าวสารผ่าน<br/>Lotus’s LINE Official Account”',
      description: 'หากคุณยกเลิกการเชื่อมต่อบัญชี LINE ออกจากสมาชิก มายโลตัส คุณจะพลาดข่าวสารและการแจ้งเตือน เกี่ยวกับสิทธิประโยชน์ และโปรโมชั่นพิเศษสำหรับคุณ เท่านั้น',
      descriptionBullet: true
    },
    actionOptions: [
      {
        text: 'ดำเนินการต่อ',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          this.openModalUnlink()
        },
      },
    ]
  }

  loadingBarLabelHtml = ''

  wnd = window as any
  async created() {
    this.wnd.addNewModal = this.addNewModal

    // Call this once when your app initializes
    this.initIframeListener()

    window.addEventListener('popstate', function() {
      liff.closeWindow()
    })

    if (window) {
      const query = this.$route.query

      if (query['x-request-id']) {
        const requestIdString = query['x-request-id'] as string
        const requestIdList = requestIdString.split(',')

        window.__LIFF_DEBUGGER_PARAMS = requestIdList ?? []
      }

      window.addEventListener('message', this.handleMessageEvent)
    }

    router = this.$router
    this.forceUpdate = this.getForceUpdateFlagByQueryParameter()
    this.setIsLoadingPoints(true)
    this.updateStaticInforByCache()
    this.handleOpenUrlClickEvent()
    this.proceedQueryParameterCommand()

    const unwatch = this.$watch(() => this.modals.length,
    async (newLength: number, oldLength: number) => {
      if (oldLength > newLength) {
        unwatch() 
        await this.createdFollowFunction()
        } 
      }
    )
    if (this.modals.length === 0) {
      await this.createdFollowFunction()
    }
  }

  async createdFollowFunction() {
    await this.initLine()
    await this.getEventCodeConfigsData()
    
    await this.getCustomerInfo()
    // Handle loading state for first loading
    if (this.isFirstLoading) {
      if (this.customerInfo?.customerType) {
        this.loading()
      }
    } else {
      this.isFirstLoading = true
    }

    await this.getBannersListStore()
    await this.getDefaultBanner()
    await this.getCampaigns()
    this.pushGameModalFromQuery()

    // Check if customer is gold tier to open gold onboard modal
    if (this.store.state.tier?.tierName?.toLocaleLowerCase() === 'gold' && getLocalStorage(KeyCache.GOLD_ONBOARD) !== true) {
      this.openModalGoldOnboard()
    }

    if (this.customerInfo) {
      if (this.customerInfo?.customerType === 'online') {
        this.store.commit('myCouponInfo/updateCouponsIsLoading', false)
        this.store.commit('myCouponInfo/updatePremiumOffersIsLoading', false)
        this.store.commit('myCouponInfo/updateVoucherOffersIsLoading', false)
        this.store.commit('myCouponInfo/updatePartnerOffersIsLoading', true)
        await this.getOffersSpecialStore()
      } else {
        this.store.commit('myCouponInfo/updateCouponsIsLoading', true)
        this.store.commit('myCouponInfo/updatePremiumOffersIsLoading', true)
        this.store.commit('myCouponInfo/updateVoucherOffersIsLoading', true)
        this.store.commit('myCouponInfo/updatePartnerOffersIsLoading', true)
        await this.getCouponsSpecialForYou()
        await this.getOffersSpecialStore()
        await this.getVoucherOffers()
        await this.getPremiumOffers()
      }
      this.setItemInfoToCache()
    }
  }

  async unmounted() {
    if (window) {
      window.removeEventListener('message', this.initIframeListener)
      window.removeEventListener('message', this.handleMessageEvent)
    }
  }

  // Add listener to handle messages from iframes
  initIframeListener() {
    window.addEventListener('message', (event: MessageEvent) => {
      const data = event.data as IframeMessage
      if (!data || !data.iframeName) return

      switch (data.type) {
        case 'STORE': {
          if (data.payload !== undefined) {
            localStorage.setItem(`iframe_storage_${data.iframeName}`, JSON.stringify(data.payload))
            console.log(`Stored data for ${data.iframeName}:`, data.payload)
          }
          break
        }
        case 'REQUEST': {
          const storedValue = localStorage.getItem(`iframe_storage_${data.iframeName}`)
          console.log(`Request data for ${data.iframeName}:`, storedValue)
          const response = {
            type: 'RESPONSE',
            iframeName: data.iframeName,
            payload: storedValue ? JSON.parse(storedValue) : null,
          }
          // Respond back to the iframe
          if (event.source && 'postMessage' in event.source) {
            // Narrow down to Window
            const targetWindow = event.source as Window
            targetWindow.postMessage(response, event.origin || '*')
          }
          break
        }
      }
    })
  }

  // Send a message to a specific iframe
  sendMessageToIframe(iframe: HTMLIFrameElement, message: IframeMessage) {
    iframe.contentWindow?.postMessage(message, '*')
  }

  async handleMessageEvent(event: MessageEvent) {
    const myCouponToken = this.store.state.lineInfo.idToken

    if (event.data?.command === 'game-coupon' || event.data?.command === 'game-brand') {
      const customerType = this.store.state.customer?.customerType ?? undefined
      const url = getUrlModalOptionsMyCoupon(event.data?.value, 'lotus', 'coupon', MyCoupon.ALL, customerType, undefined)
      modalOptionsCouponLotus.url = `${url}&action=back-to-line-web&token=${myCouponToken}`

      this.store.commit('modalIframe/updateModalIframeActive', true)
      this.store.commit('modalIframe/updateModalOptionsIframe', modalOptionsCouponLotus)
    } else if (event.data?.command === 'game-coin') {
      this.store.dispatch('coinHistory/onOpen', true)
      addGAEvent({
        event: 'mylotuss_coins_expoiry_details',
      })
    } else if (event.data === 'game-refresh-token') {
      const userToken = await this.getUserToken()
      getEventPostMessage(document.getElementsByName(Game.IFRAME_NAME), { command: 'game-token-received', value: userToken }, Game.IFRAME_NAME)
    } else if (event.data?.action === 'back-to-home') {
      const modalName = this.modals.length > 0 ? this.modals[this.modals.length - 1].name : 'iframe-game'
      this.removeModal({name: modalName} as Modal)
    } else if (event.data?.command === 'game-open-url') {
      this.openUrl(event.data?.value)
    } else if (event.data === 'refresh-line-web') {
      location.reload()
    } else if (event.data.action === 'direct-url') {
      window.location.href = event.data?.value
    } else if (event.data.action === 'open-new-window-url') {
      window.open(event.data?.value, '_blank')
    } else if (event.data.action === 'liff-open-url') {
      liff.openWindow({ url: event.data?.value })
    } else if (event.data?.action === 'open-modal-with-iframe') {
      const name = event.data?.name
      this.pushModal({
        name,
        component: markRaw(DefaultIFrame),
        props: {
          name,
          url: event.data?.url,
          token: this.lineInfo.idToken,
          queryParameter: 'channel=line',
        },
        isHiddenNavbar: true
      })
    }
  }

  async getUserToken(): Promise<string | undefined> {
    const token = this.lineInfo.idToken
    if (!token) return
    const result = await meService.getToken(token)
    if (result.httpStatusCode === 200) {
      return result.json.data?.token
    }
  }

  pushGameModalFromQuery() {
    const moduleParam = this.$route.query.module
    if (moduleParam && typeof moduleParam === 'string' && moduleParam.startsWith('game/')) {
      const gameCode = moduleParam.split('game/')[1]
      if (gameCode && this.lineInfo.idToken) {
        const customerType = this.store.state.customer.customerType

        if (customerType === CustomerTypeState.ONLINE) {
          location.href = process.env.VUE_APP_UPDATE_ACCOUNT!
          return
        } else {
          this.openModalWithIframe({
            name: 'Lucky Bag Game',
            url: `${this.gameUrl}/${gameCode}?channel=line`
          })
        }
      }
    }
  }

  async openModalWithIframe(parameter: any) {
    const { name, url, is_hidden_navbar, is_external_app, custom_query_parameter } = parameter
    if (is_external_app) {
      await this.initLine()
      this.pushModal({
        name: `${name}`,
        component: markRaw(GameIFrame),
        props: {
          url,
          token: liff.getIDToken(),
          queryParameter: decodeURIComponent(custom_query_parameter)
        },
        isHiddenNavbar: is_hidden_navbar
      })
    } else if (this.lineInfo.idToken && url) {
      this.getMyCouponToken()
      this.pushModal({
        name: `${name}`,
        component: markRaw(GameIFrame),
        props: {
          url,
          token: this.lineInfo.idToken
        },
        isHiddenNavbar: is_hidden_navbar
      })
    }
  }

  handleClickBanner(banner: CustomBanner) {
    type functionHandler = (parameters: any) => void

    const functionTypeMap: Record<string, functionHandler> = {
      //allow function to be called by banner action type
      'openModalWithIframe': this.openModalWithIframe,
      'redirectWithToken': this.redirectWithToken
    }
    // Check if the action type exists in the map
    if (banner?.action?.type && functionTypeMap[banner.action.type]) {
      functionTypeMap[banner.action.type](banner?.action.parameters)
    }
  }

  
  addNewModal = (modal: NewModal) => {
    const isAlreadyAdded = this.newModals.find((_modal) => _modal.name === modal.name)
    if (isAlreadyAdded) return
    if (!modal.index) {
      modal.index = 99999 + this.newModals.length
    }
    this.newModals.push(modal)
    console.log({ newModals: JSON.parse(JSON.stringify(this.newModals)) })
  }

  removeNewModal = (modal: NewModal) => {
    this.newModals = this.newModals.filter((_modal) => {
      const result = _modal.type !== modal.type || _modal.name !== modal.name
      return result
    })
  }

  async redirectWithToken(parameters: any) {
      const { call_back_url, destination_url, custom_query_pameters } = parameters
      if (this.customerInfo?.customerType === CustomerTypeState.UNBIND) {
        const queryString = buildQueryParams({
          channel: 'line',
          callbackUrl: call_back_url
        })
        window.location.href = `${this.webRegisUri}?${queryString}`
      }

      const token = this.lineInfo.idToken
      if (!token) return false

      // //handle module query parameter
      // const moduleParam = this.$route.query.module
      // if (moduleParam && customerType === CustomerTypeState.LOYALTY) {
      //   return false
      // }

      try {
        this.isShowingLoadingTransparency = true
        const { httpStatusCode, json } = await meService.getCustomerInfoWithExternalTokenFields(token, ['external_token'])

        if (httpStatusCode !== 200) return false

        const externalToken = json.data?.external_token

        const queryString = buildQueryParams({
          token: externalToken,
          ...custom_query_pameters,
        })

        const url = new URL(window.location.href)
        url.searchParams.delete('event_code')
        window.history.replaceState({}, document.title, url.pathname + url.search)
        window.location.href = `${destination_url}?${queryString}`

        return true
      } catch (error) {
        console.error('Error during redirect-with-token operation:', error)
        const modalOptionsNotification = modalOptionsSubmitError(this.store)
        this.store.dispatch('modalNotification/onOpen', modalOptionsNotification)
        this.isShowingLoadingTransparency = false
        return false
      }
  }

  handleOpenUrlClickEvent() {
    window.onblur = () => {
      this.openUrlHasBeenBlured = true
      this.openUrlBlurCounting++
    }
    window.onfocus = () => {
      if (this.openUrlHasBeenBlured) {
        this.closeLoadingLabel()
        this.openUrlHasBeenBlured = false
      }
    }
  }

  openOneApp(url: string) {
    liff.openWindow({
      url: url,
    })
  }

  openAppStore() {
    liff.openWindow({
      url: process.env.VUE_APP_DOWNLOAD_LOTUSS || '',
    })
  }

  openUrl(url: string) {
    if (url) {
      if (isDeeplinkFormat(url)) {
        this.showLoadingLabel()
        const previousBlur = this.openUrlBlurCounting
        this.openOneApp(url)
        setTimeout(() => {
          /*
          the app on blur state is not updated,
          we will assume the app does not open one app
          so that we will force use to open app store instead
          */
          if (previousBlur === this.openUrlBlurCounting) {
            this.openAppStore()
            this.closeLoadingLabel()
          }
        }, 2000)
      } else if (isWebsiteFormat(url)) {
        this.openOneApp(url)
      }
    }
  }

  showLoadingLabel() {
    this.store.commit('app/setIsLoadingHome', true)
    this.store.commit('app/setLoadingBarLabelHtml', 'กำลังเปิด<br/>โลตัส สมาร์ท แอพ')
  }

  closeLoadingLabel() {
    this.store.commit('app/setIsLoadingHome', false)
    this.store.commit('app/setLoadingBarLabelHtml', '')
  }

  updateStaticInforByCache() {
    const getItemInfo: CacheInfo = getLocalStorage(KeyCache.INFO)
    if (getItemInfo) {
      this.isFirstLoading = false
      this.store.commit('app/setIsLoadingHome', false)
      this.startToFadeOut = false
      if (getItemInfo.lineInfo) {
        this.store.commit('lineInfo/updateLineProfile', getItemInfo.lineInfo.profile)
        this.lineInfo = getItemInfo.lineInfo
        this.lineInfo.profile.displayName = getItemInfo.lineInfo.profile.displayName
        this.lineInfo.profile.pictureUrl = getItemInfo.lineInfo.profile.pictureUrl
        this.lineInfo.profile.statusMessage = getItemInfo.lineInfo.profile.statusMessage
        this.lineInfo.profile.userId = getItemInfo.lineInfo.profile.userId
      }
      if (getItemInfo.customerInfo) {
        this.store.commit('customer/updateCustomer', getItemInfo.customerInfo)
        this.customerInfo = getItemInfo.customerInfo
        if (this.customerInfo?.customerType === 'online') {
          this.store.commit('myCouponInfo/updateCouponsIsLoading', false)
          this.store.commit('myCouponInfo/updateVoucherOffersIsLoading', false)
          this.store.commit('myCouponInfo/updatePartnerOffersIsLoading', true)
        } else {
          this.store.commit('myCouponInfo/updateCouponsIsLoading', true)
          this.store.commit('myCouponInfo/updateVoucherOffersIsLoading', true)
          this.store.commit('myCouponInfo/updatePartnerOffersIsLoading', true)
        }
      }
      if (getItemInfo.copyRightDate) {
        this.copyRightDate = getItemInfo.copyRightDate
      }
    }
  }

  setItemInfoToCache() {
    const setItemInfo: CacheInfo = { lineInfo: this.lineInfo, customerInfo: this.customerInfo, copyRightDate: this.copyRightDate }
    setLocalStorage(KeyCache.INFO, setItemInfo)
  }

  getForceUpdateFlagByQueryParameter() {
    const query = this.$route.query
    return query && query['no-cache'] === 'true' ? true : false
  }

  wait (ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  async proceedQueryParameterCommand() {
    const { menu } = this.$route.query

    // for params menu is iframe
    if (menu === 'iframe') {
      const urlParams = new URLSearchParams(window.location.search)
      const url = urlParams.get('url')
      const is_hidden_navbar = urlParams.get('is_hidden_navbar')
      const is_external_app = urlParams.get('is_external_app')
      const custom_query_parameter = urlParams.get('custom_query_parameter')
      const iframe_name = urlParams.get('iframe_name')
      this.openModalWithIframe({
        name: iframe_name,
        url,
        is_hidden_navbar: is_hidden_navbar === 'true',
        is_external_app: is_external_app === 'true',
        custom_query_parameter
      })
    }
  }

  getConfiguratedBannerByQueryParameter() {
    const { event_code: eventCodeParam } = this.$route.query
    const configs = this.store.state.modalBanner.eventCodeConfigs

    return configs.length > 0
      ? configs.find((item) => item.event_code === eventCodeParam)
      : null
  }

  getConfiguratedBanner(customerState: string, banner: EventCodeConfigs) {
    if (!banner) return null

    const { display_period: period, image, display_mode, event_code, customer_state } = banner

    // Check display period
    if (period && !isWithinDisplayPeriod(period.start, period.end)) {
      return null
    }

    // Validate image
    if (!isValidImageUrl(image)) {
      return null
    }

    // Check "once" display mode
    if (display_mode === DisplayMode.ONCE) {
      const seenFlagKey = `banner_seen_${event_code}`
      if (getLocalStorage(seenFlagKey)) return null
      setLocalStorage(seenFlagKey, 'true')
    }

    // Check if banner is relevant to the customer state
    const isStateMatch = customer_state === CustomerTypeState.ALL || customer_state === customerState

    return isStateMatch ? banner : null
  }

  async operateBanner(customerType: string, loadingLabel?: string): Promise<boolean> {
    const configuratedBanner = this.getConfiguratedBannerByQueryParameter()
    if (!configuratedBanner) return false

    const {
      event_code,
      image,
      destination_url,
      display_type,
      onboarding,
      channel,
      custom_query_pameters,
      call_back_url,
      passing_query_parameters,
      is_supported_online
    } = configuratedBanner

    if (display_type === 'onboarding') {
      triggerHealthCheck(`onboarding/${event_code}`)
      this.onBoardingOption = {
        image,
        buttonText: onboarding?.button_text || '',
        backgroundColor: onboarding?.background_color || '',
        destinationUrl: destination_url,
      } as OnBoardingOption
      this.isShowOnBoarding = true
      return true
    }

    if (display_type === 'redirect-with-token') {

      if (customerType === CustomerTypeState.UNBIND) {
        const queryString = buildQueryParams({
          channel: 'line',
          callbackUrl: call_back_url,
          ...passing_query_parameters
        })
        window.location.href = `${this.webRegisUri}?${queryString}`
        return true
      }

      if (customerType === CustomerTypeState.ONLINE && !is_supported_online) {
        return false
      }

      const token = this.lineInfo.idToken
      if (!token) return false

      //handle module query parameter
      const moduleParam = this.$route.query.module
      if (moduleParam && customerType === CustomerTypeState.LOYALTY) {
        return false
      }

      try {
        const { httpStatusCode, json } = await meService.getCustomerInfoWithExternalTokenFields(token, ['external_token'])

        if (httpStatusCode !== 200) return false

        const externalToken = json.data?.external_token

        if (custom_query_pameters?.line_image_url) {
          const key = custom_query_pameters.line_image_url as keyof LineProfile
          if (['displayName', 'pictureUrl', 'statusMessage', 'userId'].includes(key)) {
            custom_query_pameters.line_image_url = this.lineInfo.profile[key] || ''
          }
        }
        const queryString = buildQueryParams({
          token: externalToken,
          ...custom_query_pameters,
          channel,
        })

        const url = new URL(window.location.href)
        url.searchParams.delete('event_code')
        window.history.replaceState({}, document.title, url.pathname + url.search)
        window.location.href = `${destination_url}?${queryString}`

        return true
      } catch (error) {
        console.error('Error during redirect-with-token operation:', error)
        const modalOptionsNotification = modalOptionsSubmitError(this.store)
        this.store.dispatch('modalNotification/onOpen', modalOptionsNotification)
        return false
      }
    }

    const banner = this.getConfiguratedBanner(customerType, configuratedBanner)
    if (banner) {
      triggerHealthCheck(`banner-modal/${event_code}`)
      this.store.dispatch(
        'modalBanner/onOpen',
        modalOptionsBanner(event_code, image, destination_url, true, loadingLabel)
      )
      return true
    }

    return false
  }

  async getEventCodeConfigsData() {
    await this.store.dispatch('modalBanner/fetchEventCodeConfigsList')
  }

  async getDefaultBanner() {
    const configs = this.store.state.modalBanner.eventCodeConfigs
    const customerType = this.store.state.customer.customerType
    this.defaultConfig = configs.find((item) => item.event_code === 'default' && item?.customer_state?.toLocaleLowerCase() === customerType?.toLocaleLowerCase()) ?? {}
  }

  navigateOnboarding() {
    if (!this.onBoardingOption!.destinationUrl) return
    const { event_code: eventCodeParam } = this.$route.query
    triggerHealthCheck('navigate/' + eventCodeParam)
    setTimeout(() => {
      window.location.href = this.onBoardingOption!.destinationUrl
    }, 50)
  }
  async initLine(customLiffId?: string) {
    if (liff) {
      await liff.init({
        liffId: customLiffId || this.lineLiffIdLoyalty || ''
      })
      console.log('is loggined', liff.isLoggedIn())
      await this.getMaMode()
      if (liff.isLoggedIn()) {
        const profile = await liff.getProfile()
        const idToken = liff.getIDToken()
        const socialToken = liff.getAccessToken()

        this.getProfile(profile, idToken, socialToken)
      } else {
        this.lineLogin()
      }
    }
  }

  redirect() {
    this.$router.push('/unlink')
  }
  
  async lineLogin() {
    const result = await LiffService.lineLogin()

    this.getProfile(result?.profile, result?.idToken, result?.socialToken)
  }
   
  getProfile(profile: any, token: any, socialToken: any) {
    this.lineInfo.profile.displayName = profile.displayName
    this.lineInfo.profile.pictureUrl = profile.pictureUrl
    this.lineInfo.profile.statusMessage = profile.statusMessage
    this.lineInfo.profile.userId = profile.userId
    this.lineInfo.idToken = token
    this.lineInfo.socialToken = socialToken
    
    this.store.commit('lineInfo/updateLineIdToken', token)
    this.store.commit('lineInfo/updateLineSocialToken', socialToken)
    this.store.commit('lineInfo/updateLineProfile', profile)
    window.history.replaceState({}, document.title, window.location.pathname + window.location.search)
  }

  setIsLoadingPoints (value: boolean) {
    this.store.commit('app/setIsLoadingPoints', value)
  }
  
  async getMyCouponToken() {
    const lineIdToken = this.lineInfo.idToken
    await this.store.dispatch('myCouponInfo/fetchMyCouponToken', { lineIdToken } as MyCouponInfoPayload)
  }

  async getCustomerInfo() {
    const token = this.lineInfo.idToken
    if (token) {
      this.setIsLoadingPoints(true)
      this.isLoadingCustomerProfile = true
      const result = await meService.getCustomerInfo(token, ['customer_type', 'phone_number', 'token', 'points', 'tier'], true)
      const statusCode = result.httpStatusCode
      if (statusCode === 200) {
        this.isLoadingCustomerProfile = false
        const { phone_number: phoneNumber, points, customer_type: customerType, clubcard_no: clubcardNo, copy_right_date: copyRightDate, expiry_date_of_coin: expiryDateOfCoin, tiered_points: tieredPoints, token, tier } = result.json.data   
        const data = {
          phoneNumber: getLocalFromInterPhone(phoneNumber),
          points,
          customerType,
          clubcardNo,
          expiryDateOfCoin,
          tieredPoints
        }

        this.setIsLoadingPoints(false)
        this.store.commit('customer/updateCustomer', data)
        this.store.commit('myCouponInfo/updateToken', token)
        this.store.commit('tier/updateTier', tier)
        this.customerInfo = data
        this.copyRightDate = copyRightDate

        // If customer type is online or loyalty, check is show banner to register
        await this.operateBanner(customerType, 'กำลังเปิดเว็บ')
      } else if (statusCode === 401) {
        this.isLoadingCustomerProfile = false
        liff.logout()
        const currentUrl = new URL(window.location.href)
        const queryString = currentUrl.search
        const redirectUri = `${currentUrl.origin}${currentUrl.pathname}${queryString}`
        liff.login({ redirectUri })
      } else if (statusCode === 404) {
        this.isLoadingCustomerProfile = false
        // If customer type is unlink line, check is show banner to register
        const operationResult = await this.operateBanner(CustomerTypeState.UNBIND, undefined)
        if (operationResult) {
          this.store.commit('modalBanner/updateUnlinkActive', true)
        } else {
          this.redirectToWebRegister()
        }
      } else {
        this.isLoadingCustomerProfile = false
        this.setIsLoadingPoints(false)
        throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
      }
    }
  }

  async getBannersListStore() {
    const token = this.lineInfo.idToken
    await this.store.dispatch('bannersList/fetchBannersList', { token } as BannersListPayload)
  }

  async getCampaigns() {
    const token = this.lineInfo.idToken
    await this.store.dispatch('campaignInfo/fetchCampaignList', { token } as CampaignInfoPayload)
  }

  async getCouponsSpecialForYou() {
    const token = this.lineInfo.idToken
    const tierType = this.store.state.tier?.tierName?.toLocaleLowerCase()
    const couponType = `${tierType === 'gold' ? 'Gold' : ''}${MyCouponType.SPECIAL_FOR_YOU}`
    await this.store.dispatch('myCouponInfo/fetchCouponsList', { token, couponType } as MyCouponInfoPayload)
  }

  async getPremiumOffers() {
    const token = this.lineInfo.idToken
    await this.store.dispatch('myCouponInfo/fetchPremiumOffersList', { token } as MyCouponInfoPayload)
  }

  async getVoucherOffers() {
    const token = this.lineInfo.idToken
    await this.store.dispatch('myCouponInfo/fetchVoucherOffersList', { token } as MyCouponInfoPayload)
  }

  async getOffersSpecialStore() {
    const token = this.lineInfo.idToken
    await this.store.dispatch('myCouponInfo/fetchPartnerOffersList', { token } as MyCouponInfoPayload)
  }

  redirectToWebRegister() {
    window.location.href = `https://liff.line.me/${this.lineLiffIdWebRegis}?callbackUrl=${encodeURIComponent(window.location.href)}&channel=line`
  }

  loading() {
    this.store.commit('app/setIsLoadingHome', true)
    this.startToFadeOut = true
    setTimeout(() => {
      this.store.commit('app/setIsLoadingHome', false)
      this.startToFadeOut = false
    }, 300)
  }

  openModalUnlink() {
    this.setZIndexModalUnlinkConfirmation('0')
    this.isModalActive = true
    addGAEvent({
      event: 'unlink_mylotuss_proceed'
    })
  }

  onModalClose() {
    this.setZIndexModalUnlinkConfirmation('1055')
    this.isModalActive = false
    addGAEvent({
      event: 'unlink_mylotuss_cancel'
    })
  }

  async unlinkLineAccount(reasons: ReasonList[]) {
    const token = this.lineInfo.idToken

    if (this.isInProgress) {
      return
    }

    this.isInProgress = true
    
    if (token) {
      const result = await meService.unlinkLineAccount(token,reasons)
      const statusCode = result!.httpStatusCode
    
      if (statusCode === 200) {
        removeLocalStorage(KeyCache.INFO)
        removeLocalStorage(KeyCache.MYCOUPON)
        router.push('/unlink')
      } else {
        this.isInProgress = false
        alert('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
      }
    }

    let reasonList = []
    if (reasons.length > 0) {
      for (const reason of reasons) {
        reasonList.push(reason.text_th)
      }
    }
    addGAEvent({
      event: 'unlink_mylotuss_confirm',
      unlink_reason: reasonList.join(',')
    })
  }

  openModalUnlinkConfirmation() {
    this.isModalRightFullPageActive = true
    const customerType = this.store.state.customer?.customerType
    const event = customerType === 'online' ? 'unlink_mylotuss_icon' : 'unlink_mylotuss'
    addGAEvent({
      event: event,
    })
  }

  onModalUnlinkConfirmationClose() {
    this.isModalRightFullPageActive = false
  }

  onModalBarcodeClose() {
    this.isModalBarcodeActive = false
  }

  openModalGoldOnboard() {
    addNewModal({
      type: 'modal-bottom-dynamic',
      name: 'Modal-Gold-Onboard',
      component: markRaw(ModalBottomGoldOnboard),
      props: {},
    })
  }

  openModalBarcode() {
    this.pushModal({
        name: 'qr barcode',
        component: markRaw(BarcodeModal),
        props: {
        },
        isHiddenNavbar: true
      })
      addGAEvent({
      event: 'mylotuss_barcode'
    })
  }

  setZIndexModalUnlinkConfirmation(zindex: string) {
    const modalElement = document.getElementsByClassName('modal-unlink-confirmation')[0]! as HTMLElement
    modalElement.style.zIndex = zindex
  }

  pushModal(modal: Modal) {
    if (!this.modals.find((_modal) => _modal.name.toLocaleLowerCase() === modal.name.toLocaleLowerCase())) 
      {
        modal.state = 'opened'
        modal.index = 9999 + (2 * this.modals.length)
        this.modals.push(modal)
      }
  }

  removeModal(modal: Modal) {
    const match = this.modals.find(m => m.name.toLocaleLowerCase() === modal.name.toLocaleLowerCase())

    if (match) {
      match.state = 'closed'
      setTimeout(() => {
        this.modals = this.modals.filter(m => m.name.toLocaleLowerCase() !== modal.name.toLocaleLowerCase())
      }, 300)
    }
  }

  async getMaMode() {
    try {
      const result = await getConfigurationsMaMode('line-web-loyalty')
      const statusCode = result.httpStatusCode
      if (statusCode !== 200) {
        throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
      }

      const config = result?.json?.data

      if (!config?.isActive) return

      const isMaMode = getDateStatus(config.startDate, config.endDate) === 'active'
      const redirectUrl = config.redirectUrl

      if (isMaMode && redirectUrl) {
        const separator = redirectUrl.includes('?') ? '&' : '?'
        window.location.href = `${redirectUrl}${separator}lang=th`
      }
    } catch (e) {
      console.error('[getMaMode]', e)
    }
  }
}
